<template>
  <div>
    <login-modal v-show="loginIsShow" @close-modal="loginClose" v-bind="loginData"/>
  </div>
</template>

<script>
  import Vuex
    from 'vuex';
  import {throttle} from 'lodash';
  import LoginModal
    from '../common/modal/Login';

  export default {
    components: {
      LoginModal,
    },
    computed: {
      ...Vuex.mapState(['loginIsShow','data']),
      loginData() {
        return {
          isShow: this.loginIsShow,
          isMobileapp: this.data.isMobileapp,
          bodyText: "ログインすると「待つと無料」作品が1日1話読めるようになります",
        };
      },
    },
    methods: {
      ...Vuex.mapActions(['initData', 'setData', 'setLoginIsShow', ]),

      loginClose() {
        this.setLoginIsShow(false);
      },
      showLoginModal() {
        this.setLoginIsShow(true);
        return false;
      },
    },
    created() {
      // django templateの変数を取得する
      this.initData(document.getElementById('sukima-modal-data').dataset);
      //  連打対応
      // this.loginConfirm = throttle(this.showModal.bind(this), 2000);
    },
    mounted() {
      Array.from(document.querySelectorAll('.js-showLoginModal')).forEach(elm => {
        elm.onclick = throttle(this.showLoginModal.bind(this), 2000);
      }, this);
    },
  };
</script>
